import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.MODULE_REPORT_SET_LOADER,
        value: data
    }
};

export const reportICDPasien = (value) => {
    return {
        type: types.MODULE_REPORT_LISTDATA_ICD_PASIEN,
        value
    }
};

export const reportKunjunganPasien = (value) => {
    return {
        type: types.MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN,
        value
    }
}

export const handleStateReportOuter = (property, value) => {
    return {
        type: types.MODULE_REPORT_HANDLE_STATE_OUTER,
        property,
        value
    }
};


